import { render, staticRenderFns } from "./WebNavigation.vue?vue&type=template&id=5a4f1172"
import script from "./WebNavigation.vue?vue&type=script&lang=js"
export * from "./WebNavigation.vue?vue&type=script&lang=js"
import style0 from "./WebNavigation.vue?vue&type=style&index=0&id=5a4f1172&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports